import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { applyStoredTheme } from "./theme";
import "./styles.css";

// Aplica el tema guardado antes del primer render para evitar un destello de otro tema.
applyStoredTheme();


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

